export default __webpack_public_path__ + "527dcd913c23a942e2068912c471c040.svg";